
import { DailyNewSubscription, Customer } from './types';
import { isPendingUser } from './customerUtils';
import { toZonedTime } from 'date-fns-tz';

/**
 * Calculates new subscriptions by day for recent days
 */
export const calculateNewSubscriptionsByDay = (customerData: Customer[]): DailyNewSubscription[] => {
  if (!customerData || customerData.length === 0) {
    return [];
  }
  
  // Use New Zealand timezone for date calculations
  const today = toZonedTime(new Date(), 'Pacific/Auckland');
  const days = 7; // Last 7 days
  
  const newSubscriptionData: DailyNewSubscription[] = [];
  
  // Generate data points for each day
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD format
    
    // Get start and end timestamps for the current day in NZ timezone
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    
    // Count new subscriptions created on this specific date
    const newSubscriptionsOnDate = customerData.filter(customer => {
      const createdAt = toZonedTime(new Date(customer.created_at), 'Pacific/Auckland');
      return createdAt >= startOfDay && createdAt <= endOfDay;
    });
    
    // Use the same helper function for pending users
    const newPendingCount = newSubscriptionsOnDate.filter(customer => isPendingUser(customer)).length;
    const newMonthlyCount = newSubscriptionsOnDate.filter(c => c.plan === "monthly" && c.status !== "canceled").length;
    const newAnnualCount = newSubscriptionsOnDate.filter(c => c.plan === "annual" && c.status !== "canceled").length;
    const newLifetimeCount = newSubscriptionsOnDate.filter(c => c.plan === "lifetime" && c.status !== "canceled").length;
    
    const total = newPendingCount + newMonthlyCount + newAnnualCount + newLifetimeCount;
    
    console.log(`New subscriptions for ${dateStr}: pending=${newPendingCount}, monthly=${newMonthlyCount}, annual=${newAnnualCount}, lifetime=${newLifetimeCount}, total=${total}`);
    
    const dataPoint: DailyNewSubscription = {
      date: dateStr,
      pending: newPendingCount,
      monthly: newMonthlyCount,
      annual: newAnnualCount,
      lifetime: newLifetimeCount,
      total: total
    };
    
    newSubscriptionData.push(dataPoint);
  }
  
  return newSubscriptionData;
};
